import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { UserInfoBox } from "./usercard-styles";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import { useTheme } from "@mui/material";
import { styled, alpha } from "@mui/material";

export const UserCard = () => {
  const theme = useTheme();

  const userInfoBox = (
    <UserInfoBox
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          color: "text.other",
        }}
        variant="boldHeaderText"
      >
        5.9k
      </Typography>
      <Typography variant="caption">Follow</Typography>
    </UserInfoBox>
  );

  return (
    <>
      <Box
        p={5}
        sx={{
          textAlign: "center",
        }}
      >
        <Avatar
          alt="Remy Sharp"
          src="http://admin.pixelstrap.com/viho/assets/images/dashboard/1.png"
          sx={{
            width: theme.spacing(10),
            height: theme.spacing(10),
            margin: "auto",
            backgroundColor: alpha(theme.palette.primary.main, 0.4),
            // backgroundSize: theme.spacing(30),
          }}
        />

        <Box my={3}></Box>

        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
          }}
        >
          Takudzwa Makusha
        </Typography>

        <Typography variant="subtitle2">Data Scientist</Typography>

        <Box
          mt={3}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {userInfoBox}
          <Divider orientation="vertical" variant="middle" flexItem />
          {userInfoBox}
          <Divider orientation="vertical" variant="middle" flexItem />
          {userInfoBox}
        </Box>
      </Box>
    </>
  );
};
